import getReducerHandler from '../../../providers/getReducerHandler'
// import handleReducerSimpleSetter from '../../../providers/handleReducerSimpleSetter' // uncomment if need to set single property

export const ACTIONS = Object.freeze({
  RESET_STATE: 'RESET_STATE',
  ADD_AVAILABLE_AVATAR: 'ADD_AVAILABLE_AVATAR',
  SET_BY_PERSON_ID: 'SET_BY_PERSON_ID',
  SET_SELECTOR_PERSON_ID: 'SET_SELECTOR_PERSON_ID',
  SET_ACTIVE_AVATAR: 'SET_ACTIVE_AVATAR',
  DELETE_ACTIVE_AVATAR: 'DELETE_ACTIVE_AVATAR',
})

export const initialValues = {
  avatarSelectorPersonId: 'CURRENT',
  activeAvatar: null,
  availableAvatars: [],
}

/*
 * --- INDIVIDUAL ACTION HANDLERS ---
 * (Set multiple values & merge/processing logic only, otherwise use handleReducerSimpleSetter)
 */

const handleResetState = () => ({ ...initialValues })

const handleAddAvailableAvatar = (state, action) => {
  const newAvatars = [...state.availableAvatars]
  const match = newAvatars.find((avatar) => avatar?.avatarId === action.value.avatarId)

  if (!match) {
    newAvatars.push({ ...action.value })
    if (action.value.active) state.activeAvatar = action.value
  } else match.avatarUrl = action.value.avatarUrl
  return {
    ...state,
    availableAvatars: newAvatars?.length > 0 ? [...newAvatars] : state.availableAvatars,
  }
}

const handleSetByPersonId = (state, action) => {
  const availableAvatars = [...(action?.value?.availableAvatars || [])]
  const personsAvatars = availableAvatars?.filter((avatar) => avatar?.forPersonId === state?.avatarSelectorPersonId)
  const personsActive = personsAvatars.find((avatar) => avatar?.active)
  return {
    ...state,
    activeAvatar: personsActive,
    availableAvatars: [...personsAvatars],
  }
}

const handleSetSelectorPersonId = (state, action) => ({
  ...state,
  avatarSelectorPersonId: !action.value || action?.value?.forPersonId === null ? 'CURRENT' : action?.value?.forPersonId,
})

const handleSetActiveAvatar = (state, action) => {
  if (!action.value || action.value?.avatarId === null) return { ...state, activeAvatar: null }
  const updatedAvatars = state.availableAvatars?.map((avatar) => ({
    ...avatar,
    active: Boolean(avatar?.avatarId === action.value?.avatarId),
  }))
  return {
    ...state,
    activeAvatar: { ...action.value, active: true },
    availableAvatars: updatedAvatars,
  }
}

const handleDeleteActiveAvatar = (state) => {
  const { availableAvatars } = state
  const newAvatars = availableAvatars.filter(({ active }) => !active)
  return {
    ...state,
    availableAvatars: newAvatars,
    activeAvatar: null,
  }
}

// --- Handlers registry ---
const handlers = {
  [ACTIONS.RESET_STATE]: handleResetState,
  [ACTIONS.ADD_AVAILABLE_AVATAR]: handleAddAvailableAvatar,
  [ACTIONS.SET_BY_PERSON_ID]: handleSetByPersonId,
  [ACTIONS.SET_SELECTOR_PERSON_ID]: handleSetSelectorPersonId,
  [ACTIONS.SET_ACTIVE_AVATAR]: handleSetActiveAvatar,
  [ACTIONS.DELETE_ACTIVE_AVATAR]: handleDeleteActiveAvatar,
}

export default function selectorReducer(state, action) {
  return getReducerHandler(state, action, handlers)
}
